import React from "react";

export const PLANTING_TIP_APPEARS_IN_APP =
  "Esta mesma dica aparece no app também para o operador de campo.";

export function PlantingTipAppearsInAppNote() {
  return (
    <p className="service-order-planting-tip-app-note">
      {PLANTING_TIP_APPEARS_IN_APP}
    </p>
  );
}
